import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PreOrderState } from '../../types/types.preorders';

const initialState: PreOrderState = {
  Mode: 'view',
  ModePatient: 'view',
  Notes: [],
  PreOrder: { AditionalFields: {}, Cz_Cn_Id: 0, Cz_Id: 0 },
  IdPreOrder: -1,
  ModalPatient: false,
  LoadingPatient: false,
  Loading: false,
  PatientData: null,
};

//Encargado de manejar todas las órdenes del sistema y configuración general

export const preorderSlice = createSlice({
  name: 'PreOrderGlobal',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.Loading = action.payload;
    },
    setMode: (state, action: PayloadAction<{ mode: 'new' | 'update' | 'view' | 'loading'; idPreOrder?: number }>) => {
      state.Mode = action.payload.mode;
      state.Loading = false;

      if (action.payload.mode === 'new') {
        state.PreOrder = { AditionalFields: {}, POrd_Id: 0 };
        state.PatientData = null;
      }
      if (action.payload.mode === 'view' && action.payload.idPreOrder !== -1) {
        state.PreOrder.POrd_Id = action.payload.idPreOrder;
      }
      if (action.payload.mode === 'view' && action.payload.idPreOrder === -1) {
        state.PreOrder = { AditionalFields: {}, POrd_Id: 0 };
        state.PatientData = null;
      }
    },
    setData: (state, action: PayloadAction<any>) => {
      //Asignar los datos pero eliminar el nodo paciente, ya que este va en state.PatientData y eliminar el nodo Detalle
      state.PreOrder = { ...action.payload };
      //El nodo Cz_CamposDinamicos es el equivalente a AditionalFields, solo que actualmente esta como string, asi que se convierte a objeto y se asigna
      if (state.PreOrder.POrd_CamposDinamicos) {
        state.PreOrder.AditionalFields = JSON.parse(state.PreOrder.POrd_CamposDinamicos);
      }
      delete state.PreOrder.POrd_CamposDinamicos;
      delete state.PreOrder.Paciente;
      delete state.PreOrder.Detalle;
      //Asignar el paciente
      state.PatientData = action.payload.Paciente;
      state.Mode = 'view';
    },
    setPatient: (state, action: PayloadAction<any>) => {
      state.PatientData = action.payload;
    },
    clearPatient: (state) => {
      state.PatientData = { Pc_Identificacion: '' };
    },
    clearQuotation: (state) => {
      state = initialState;
    },
    updateFieldPreOrder: (state, action: PayloadAction<{ field: string; castMode: 'UPPER' | 'LOWER' | null; value: any }>) => {
      const { field, castMode, value } = action.payload;
      let resp = value;
      switch (castMode) {
        case 'LOWER':
          resp = value.toString().toLocaleLowerCase();
          break;
        case 'UPPER':
          resp = value.toString().toUpperCase();
          break;
      }
      if (field.includes('AditionalFields')) {
        state.PreOrder.AditionalFields[field.split('.')[1]] = resp;
        return;
      }
      state.PreOrder[field] = resp;
    },
  },
});

export const { setLoading, setMode, setPatient, clearPatient, updateFieldPreOrder, clearQuotation, setData } = preorderSlice.actions;
